import _keys from 'lodash/keys';
import get from 'lodash/get';

const parseErrorFromAPI = (error) => {
    // Write code for handling errors from API here.
    if (typeof error === 'object') {
        if (error.detail) return error.detail;
        if (error.error && error.error_description) return error.error_description; // StudentBeans error
        if (typeof error.billing_address === 'object') {
            const keys = _keys(error.billing_address);
            const msg = keys.length ? get(error.billing_address[keys[0]], '0') : null;
            return msg ? `Billing address error - ${keys[0]}: ${msg}` : Strings.defaultErrorMessage;
        }
        const keys = _keys(error);
        return keys.length ? (get(error[keys[0]], '0') || Strings.defaultErrorMessage) : Strings.defaultErrorMessage;
    }
    return Strings.defaultErrorMessage;
};

export default (e) => {
    const defaultErrorMessage = Strings.defaultErrorMessage;

    if (!e) return defaultErrorMessage;

    // Handle string errors.
    if (typeof e === 'string') return e;

    // Handle JS errors.
    if (e instanceof Error) return e.message || defaultErrorMessage;

    // Handle status codes
    if (e.httpStatus) {
        switch (e.httpStatus) {
            case 504: // Gateway timeout
                return Strings.gatewayTimeoutError;
            case 402: // Payment required
                if (!e._bodyText) return 'PAYMENT_REQUIRED';
                break;
            default:
                break;
        }
    }

    // Handle API errors
    try {
        if (e._bodyText && e._bodyText !== `{"detail":"Unable to retrieve next subscription"}`) {
            bugsnagClient.notify(new Error('Got error body from API'), {
                beforeSend: report => {
                    // this metaData will override the original metaData
                    if (e.url && e.status) {
                        report.metaData = {
                            url: e.url,
                            status: e.status,
                            bodyText: e._bodyText,
                        }
                    }
                }
            });
            const error = JSON.parse(e._bodyText);
            return parseErrorFromAPI(error) || defaultErrorMessage;
        }
        bugsnagClient.notify(new Error('Got empty body from API'), {
            beforeSend: report => {
                // this metaData will override the original metaData
                if (e.url && e.status) {
                    report.metaData = {
                        url: e.url,
                        status: e.status,
                    }
                }
            }
        });
        return defaultErrorMessage;
    } catch (err) {
        return defaultErrorMessage;
    }
};
